import { useCallback } from 'react';
import { escapeEmojis } from 'modules/codeless-events/utils/stringUtils';

export const useHandleButtonAnalyzerClick = ({
    currentConversion,
    updateDraftEvent,
    selectedButtons = [],
    setSelectedButtons,
    setFocusedConversionId,
}) => {
    return useCallback(
        buttonData => {
            if (currentConversion && buttonData) {
                const eventId = currentConversion.id;

                const isAlreadySelected = selectedButtons.some(btn => btn.selector === buttonData.path);

                let newSelectedButtons;
                if (isAlreadySelected) {
                    newSelectedButtons = selectedButtons.filter(btn => btn.selector !== buttonData.path);
                } else {
                    const newButton = {
                        displayText: escapeEmojis(buttonData.eventName),
                        displayTextUnescaped: buttonData.eventName,
                        selector: buttonData.path,
                        valueSelector: undefined,
                    };
                    newSelectedButtons = [...selectedButtons, newButton];
                }

                setSelectedButtons(newSelectedButtons);

                if (updateDraftEvent) {
                    updateDraftEvent(draft => ({
                        ...draft,
                        trackedElements: newSelectedButtons,
                    }));
                }

                if (setFocusedConversionId) {
                    setFocusedConversionId(eventId);
                }
            }
        },
        [currentConversion, selectedButtons, setSelectedButtons, updateDraftEvent, setFocusedConversionId]
    );
};
